const liftStationWrapper = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  height: '100%',
  width: '100%',
  '@media (max-width:600px)': {
    marginLeft: '25px',
  },
};

// const liveDataBox = {
//   border: '1px solid yellow',
//   display: 'grid',

//   marginBottom: '20px',
//   gridTemplateColumns: 'repeat(2, 1fr)',
//   placeItems: 'center',
//   '& > :nth-of-type(odd)': {
//     // borderRight: '1px solid grey',
//     pr: '12px',
//     '@media (max-width:600px)': {
//       pr: '6px',
//     },
//   },
//   '& > :nth-of-type(even)': {
//     pl: '12px',
//     '@media (max-width:600px)': {
//       pl: '6px',
//     },
//   },
// };

const liveDataBox = {
  display: 'flex',
  justifyContent: 'center',
};

export { liftStationWrapper, liveDataBox };
